<template>
  <div
    :class="['progressbar', { disabled: disabled }]"
    data-wptv="progress-bar-container">
    <div
      v-if="text && textAbove"
      class="progressbar-label">
      {{ text }}
    </div>
    <progress
      aria-hidden="true"
      max="100"
      :value="progressValueCaped" />
    <div
      v-if="text && !textAbove"
      class="progressbar-label">
      {{ text }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'WptvProgressBar',
  props: {
    progressValue: {
      type: Number,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: ''
    },
    textAbove: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    progressValueCaped () {
      return isNaN(this.progressValue) || this.progressValue === undefined ? 0 : Math.min(100, Math.max(0, this.progressValue))
    }
  }
}
</script>

<style lang="scss">
@import '../../scss/abstracts/variables';

progress, progress[value]::-webkit-progress-bar {
  background-color: rgba(155, 155, 155, 0.5);
}
.disabled {
  progress[value] {
    // keep -moz and -webkit seperated, otherwise it doesn't work
    &::-moz-progress-bar {
      background-color: #555
    }
    &::-webkit-progress-value {
      background-color: #555
    }
    &::-webkit-progress-bar {
      background-color: $lightgrey;
    }
  }
}
</style>
